import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { t } = useLanguage();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1);
    toast.success(`${product.name} ${t.product.addToCart.toLowerCase()}`);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(price);
  };

  const getCategoryName = (category) => {
    switch(category) {
      case 'dewalt-batteries': return t.nav.powerTools;
      case 'milwaukee-batteries': return t.nav.handTools;
      case 'makita-batteries': return t.nav.accessories;
      case 'tools-accessories': return t.nav.toolsAccessories;
      default: return category;
    }
  };

  return (
    <Link 
      to={`/product/${product.id}`}
      className="product-card relative border border-zinc-800 bg-[#050505] group flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      {product.is_bestseller && (
        <div className="absolute top-0 left-0 z-10 bg-yellow-400 text-black font-mono text-[10px] sm:text-xs tracking-widest uppercase px-2 py-0.5 sm:px-3 sm:py-1" data-testid="bestseller-badge">
          {t.product.bestseller}
        </div>
      )}

      <div className="aspect-square w-full bg-[#111111] overflow-hidden">
        {product.image_url ? (
          <img 
            src={product.image_url} 
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ease-out"
            loading="lazy"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-600">
            <span className="font-mono text-xs sm:text-sm">No Image</span>
          </div>
        )}
      </div>

      <div className="p-2 sm:p-4 md:p-6 flex flex-col flex-1">
        <span className="font-mono text-[10px] sm:text-xs tracking-widest uppercase text-yellow-500 mb-1 sm:mb-2">
          {getCategoryName(product.category)}
        </span>

        <h3 className="font-heading text-sm sm:text-xl md:text-2xl uppercase text-white group-hover:text-yellow-400 transition-colors mb-1 sm:mb-2 flex-1 line-clamp-2" data-testid="product-title">
          {product.name}
        </h3>

        <div className="flex items-center justify-between mt-2 sm:mt-4">
          <span className="font-mono text-sm sm:text-xl text-yellow-500" data-testid="product-price">
            {formatPrice(product.price)}
          </span>
          <button 
            onClick={handleAddToCart}
            className="p-2 sm:p-3 bg-[#111111] border border-zinc-700 text-white hover:bg-yellow-400 hover:text-black hover:border-yellow-400 transition-colors"
            data-testid="add-to-cart-btn"
            aria-label={t.product.addToCart}
          >
            <ShoppingCart size={16} className="sm:w-5 sm:h-5" strokeWidth={2} />
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
